import isObject from './isObject';

function log({
  target,
  value,
  key,
  guards,
  guard,
}: {
  target: unknown;
  value: unknown;
  key: unknown;
  guard?: unknown;
  guards?: unknown[];
}): void {
  // eslint-disable-next-line no-console
  console.groupCollapsed(`All guards failed for key=${String(key)}`);
  // eslint-disable-next-line no-console
  console.log('key', key);
  // eslint-disable-next-line no-console
  console.log('value', value);
  // eslint-disable-next-line no-console
  console.log('target', target);
  if (guards) {
    // eslint-disable-next-line no-console
    console.log('guards', guards);
  }
  if (guard) {
    // eslint-disable-next-line no-console
    console.log('guard', guard);
  }
  // eslint-disable-next-line no-console
  console.groupEnd();
}

export default function isValidInterface<T>(
  target: unknown,
  fieldGuards: FieldGuards<T>,
  { silent = false } = {},
): target is T {
  return (
    isObject<{ [index: string]: unknown; [index: symbol]: unknown }>(target)
    && [...Object.keys(fieldGuards), ...Object.getOwnPropertySymbols(fieldGuards)].every((key) => {
      const guards = fieldGuards[key as keyof T];
      const value = target[key as keyof T];
      let result: boolean;

      if (Array.isArray(guards)) {
        result = guards.some((guard) => guard(value));

        if (!result && !silent) {
          log({
            key,
            value,
            target,
            guards,
          });
        }
      } else {
        const guard = guards as FieldGuard;
        result = guard(value);
        if (!result && !silent) {
          log({
            key,
            value,
            target,
            guard,
          });
        }
      }

      return result;
    })
  );
}

export function bindIsValidInterface<T>(fieldGuards: FieldGuards<T>) {
  return (value: unknown): value is T => isValidInterface(value, fieldGuards);
}
